import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconDirective } from './svg-icon.directive';
import { EntitySvgIconDirective } from './entity-svg-icon.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    SvgIconDirective,
    EntitySvgIconDirective,
  ],
  exports: [
    SvgIconDirective,
    EntitySvgIconDirective,
  ]
})
export class SvgIconModule {
}
